module.exports = __webpack_public_path__ + "img/ic_nav_planen.4aaf7ba5.svg";